import { render } from "./Contact.vue?vue&type=template&id=1823aa3e"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.css?vue&type=style&index=0&lang=css"

import exportComponent from "C:\\Users\\Kwassim\\Documents\\Projects\\AcquaPalace\\vueapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__